import { useContext, useEffect, useState } from "react";
import api from "../../../js/api";
import './Questions.scss';
import Button from "../../../components/Button/Button";
import { Navigate, useNavigate } from "react-router-dom";
import { UserContext } from "../../../js/UserContext";
import { hasRole } from "../../../js/utils";

export default function Questions() {

    const { user, loading } = useContext(UserContext);

    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        try {
            api.get('/questions', { silent: true }).then((data) => {
                if (data.error) {
                    console.error('Error fetching questions:', data.error);
                    return;
                }
                setQuestions(data);
            });
        } catch (error) {
            console.error('Error fetching questions:', error);
        }
    }, []);

    const filteredQuestions = (questions) => {
        return questions.filter(q => hasRole(user, 'root') || q.is_active);
    }

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div id="questions">
            <div className="centered-container gap">
                <h1>Preguntas</h1>
                {questions.length === 0 ? (
                    <p>No questions available.</p>
                ) : (
                    <div className="flex flex-column gap width-80 questions-container">
                        {filteredQuestions(questions).map((question, index) => (
                            <div key={index} className="flex gap flex-space-between question-item">
                                <div className="flex gap flex-center">
                                    <p>{question.id}.</p>
                                    <Button text={question.question} onClick={() => navigate(`/preguntas/${question.id}`)} />
                                </div>
                                <div className="flex gap flex-center">
                                    <span className="material-icon icon-button" onClick={() => {
                                        api.put(`/questions/${question.id}`, { is_active: !question.is_active }).then((data) => {
                                            if (data.error) {
                                                alert('Error al cambiar el estado de la pregunta: ' + data.error);
                                                return;
                                            }
                                            api.get('/questions', { silent: true }).then((qData) => {
                                                if (qData.error) {
                                                    console.error('Error fetching questions:', qData.error);
                                                    return;
                                                }
                                                setQuestions(qData);
                                            });
                                        });
                                    }}>{question.is_active ? 'how_to_vote' : 'block'}</span>

                                    {hasRole(user, 'root') && <span className="material-icon icon-button" onClick={async () => {
                                        if (!window.confirm('¿Estás seguro de que quieres eliminar esta pregunta?')) {
                                            return;
                                        }

                                        const data = await api.delete(`/questions/${question.id}`)
                                        if (data.error) {
                                            alert('Error al eliminar la pregunta: ' + data.error);
                                            return;
                                        }

                                        setQuestions(questions.filter(q => q.id !== question.id));
                                    }}>delete</span>}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {hasRole(user, 'root') &&
                    <>
                        <br />
                        <input className="input" type="text" placeholder="Nueva pregunta" id="new-question-input" />
                        <Button text="Crear nueva pregunta" onClick={async () => {
                            const input = document.getElementById('new-question-input');
                            const questionText = input.value;
                            if (!questionText) {
                                alert('Por favor, introduce el texto de la pregunta.');
                                return;
                            }

                            const data = await api.post('/questions', { question: questionText })
                            if (data.error) {
                                alert('Error al crear la pregunta: ' + data.error);
                                return;
                            }

                            const questions = await api.get('/questions', { silent: true });
                            if (questions.error) {
                                console.error('Error fetching questions:', questions.error);
                                return;
                            }
                            setQuestions(questions);

                            input.value = '';
                        }} />

                        <Button text="Añadir usuario" onClick={async () => {
                            const login = prompt('Introduce el login del usuario a añadir:');
                            if (!login) {
                                return login === '' ? alert('El login no puede estar vacío.') : null;
                            }

                            const user = await api.get(`/users/${login}`, { silent: true });
                            if (user.error) {
                                alert('Error al buscar el usuario: ' + user.error);
                                return;
                            }

                            const res = await api.put(`/users/${login}`, { tag: 'newyear' });
                            if (res.error) {
                                alert('Error al añadir el tag al usuario: ' + res.error);
                                return;
                            }

                            alert(`Usuario ${login} añadido con éxito.`);
                        }} />
                    </>
                }
            </div>
        </div>
    );
}